import { NavLink, Outlet, useNavigate } from "react-router-dom";
import {
  LayoutDashboard, BookOpen, Users, Tags, Download, Star, Mail, AtSign, LogOut, ExternalLink, ShoppingBag, UserCheck,
} from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const NAV = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/admin/portada", label: "Banners portada", icon: Star },
  { to: "/admin/libros", label: "Libros", icon: BookOpen },
  { to: "/admin/ventas", label: "Ventas", icon: ShoppingBag },
  { to: "/admin/clientes", label: "Clientes", icon: UserCheck },
  { to: "/admin/autores", label: "Autores", icon: Users },
  { to: "/admin/categorias", label: "Categorías", icon: Tags },
  { to: "/admin/gratis", label: "Gratis", icon: Download },
  { to: "/admin/contactos", label: "Contactos", icon: Mail },
  { to: "/admin/suscriptores", label: "Newsletter", icon: AtSign },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#eceae4] flex">
      <aside className="w-60 bg-[#0f2544] text-white flex flex-col fixed h-full">
        <div className="px-6 py-6 border-b border-white/10">
          <div className="font-serif text-xl font-semibold">Editorial Harvest</div>
          <p className="text-[0.65rem] tracking-[0.2em] text-[#a9b4ff] uppercase mt-1">Administración</p>
        </div>
        <nav className="flex-1 px-3 py-4 space-y-1 overflow-y-auto">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.end}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm transition-colors ${
                  isActive ? "bg-[#1f44e0] text-white" : "text-[#9aa6b6] hover:bg-white/5 hover:text-white"
                }`
              }
              data-testid={`admin-nav-${n.label.toLowerCase()}`}
            >
              <n.icon size={17} /> {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="px-3 py-4 border-t border-white/10">
          <a
            href="/"
            target="_blank"
            rel="noreferrer"
            className="flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm text-[#9aa6b6] hover:bg-white/5 hover:text-white w-full transition-colors mb-1"
            data-testid="admin-view-site"
          >
            <ExternalLink size={17} /> Ver la web
          </a>
          <div className="px-3 text-xs text-[#9aa6b6] mb-2 truncate">{user?.email}</div>
          <button
            onClick={() => { logout(); navigate("/admin/login"); }}
            className="flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm text-[#9aa6b6] hover:bg-white/5 hover:text-white w-full transition-colors"
            data-testid="admin-logout"
          >
            <LogOut size={17} /> Cerrar sesión
          </button>
        </div>
      </aside>
      <div className="flex-1 ml-60 p-8">
        <Outlet />
      </div>
    </div>
  );
}
